<template>
  <div>
    <v-tabs
    v-model="tipsRef"
    slider-color="#019d8c"
    class="pf-tabs-teal-sm pf-tab pf-border-lighter-1 inner-tabs chat-tabs"
    @change="tabsChanged"
    >
      <v-tab href="#tab-1">Tips</v-tab>
      <v-tab href="#tab-2">Comments</v-tab>
      <v-layout class="flex-end">
        <v-btn icon dark @click="close" title="Close">
          <v-icon class="pf-text-teal">close</v-icon>
        </v-btn>
      </v-layout>

      <v-tab-item value="tab-1">
        <v-card-text class="pa-2">
          <!-- Tips -->
          <v-layout wrap v-html="tipsText">
          </v-layout>
        </v-card-text>
      </v-tab-item>

      <v-tab-item value="tab-2">
        <!-- Comments -->
        
        <v-card-text class="conversation_content">
          <div class="loading-overlay" v-if="loadingMessages">
            <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
          </div>
          <vue-perfect-scrollbar class="messages-conversation">
            <p class="pt-5 text-center mt-2 grey--text title font-weight-light" v-if="!data[identifier] || !data[identifier].message || !data[identifier].message.length">No comments</p>
            <template v-for="(item, index) of data[identifier] ? data[identifier].message : []" >
              <div v-if="item.message.human !== null" :class="{ 'reverse': session.user().id === item.message.createdBy }" class="messaging-item layout row my-4" :key="index">
                <v-avatar class="teal mx-1" size="36">
                  <template v-if="item.message.human.account">
                    <img class="white" v-if="(item.message.human.account && item.message.human.account.avatar ? item.message.human.account.avatar : '') !== ''" :src="item.message.human.account.avatar" alt="">
                    <span v-else class="white--text subheading pa-2">
                      {{ session.user().id === item.message.createdBy ? Account.name.substr(0,2) : item.message.human.account.name.substr(0,2) }}
                    </span>
                  </template>
                  <template v-else>
                    <img class="white" v-if="(item.message.human.agency.avatar ? item.message.human.agency.avatar : '') !== ''" :src="[item.message.human.agency.avatar ? item.message.human.agency.avatar : '']" alt="">
                    <span v-else class="white--text subheading pa-2">
                    {{ session.user().id === item.message.createdBy ? item.message.human.agency.name.substr(0,2) : item.message.human.agency.name.substr(0,2) }}
                    </span>
                  </template>
                </v-avatar>
                <div>
                  <div class="messaging--body column mx-2">
                    <div class="message" v-html="item.message.content"></div>
                  </div>
                  <v-container py-0 ma-0 v-if="session.user().id === item.message.createdBy">
                    <v-layout row justify-space-between class="caption mb-2 text--secondary">
                      <v-flex xs4 class="pa-0 ma-0 text-xs-left seen" v-if="item.message.is_seen === true && item.message.createdBy == session.user().id" >
                        <v-icon small color="blue lighten-3">fas fa-circle</v-icon>
                        Seen
                      </v-flex>
                      <v-flex v-else xs4 class="pa-0 ma-0 text-xs-left seen"></v-flex>
                      <v-flex xs8 class="pa-0 ma-0  text-xs-right">
                        {{ moment.tz((new Date(item.message.createdAt)).toISOString(), moment.tz.guess()).fromNow()}}
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <v-container v-else py-0 ma-0>
                    <v-layout row justify-space-between class="caption mb-2 text--secondary">
                      <v-flex xs8 class="pa-0 ma-0 text-xs-left">
                        {{ moment.tz((new Date(item.message.createdAt)).toISOString(), moment.tz.guess()).fromNow()}}
                      </v-flex>
                      <v-flex xs4 class="pa-0 ma-0  text-xs-right"></v-flex>
                    </v-layout>
                  </v-container>
                </div>
                <v-spacer></v-spacer>
              </div>
            </template>
          </vue-perfect-scrollbar>

          <v-flex>
            <v-text-field
              v-model="message.content"
              class="input-send-msg"
              full-width
              flat
              clearable
              solo
              dense
              append-icon="send"
              @keyup.enter.prevent="send"
              placeholder="Type message here"
              label=""
              :disabled="!!session.getSession().adminUser"
              @click:append="send"
            >
            </v-text-field>
          </v-flex>

        </v-card-text>

        <!-- <v-divider v-if="!session.getSession().adminUser"></v-divider> -->
        <v-card-actions class="pt-0 new-message-section">
          
        </v-card-actions>        
      </v-tab-item>

    </v-tabs>
  </div>
</template>
<script>

/* global session */
import Vue from 'vue';
import moment from 'moment-timezone';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
export default {
  name: 'profile-comments',
  components: {
    VuePerfectScrollbar
  },
  props: {
    loadingMessages: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      required: true
    },
    tipsTabs: {
      type: String
    },
    identifier: {
      type: String,
      required: true
    },
    tipsText: {
      type: String,
      required: true
    },
    message: {
      type: Object,
    }
  },
  data: () => ({
    session: session,
    moment: moment
  }),
  computed: {
    tipsRef: {
      get () {
        return this.tipsTabs;
      },
      set (value) {
        // 
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    // 
  },
  methods: {
    send () {
      this.$emit('send');
    },
    close () {
      this.$emit('close');
    },
    tabsChanged (tabId) {
      if (tabId) {
        this.$emit('changed', tabId);
      }
    }
  }
};
</script>


<style scoped>
  .messages-conversation {
    height: 430px;
  }
  .conversation_content {
    max-height: 500px;
    padding: 5px;
  }
  .loading-overlay {
      z-index: 1;
      top: 0;
      left: 0;
      right: 0;
      position: absolute;
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, 0.9);
      display: flex;
      align-items: center;
      justify-content: center;
  }
  .messaging--body {
    padding: 10px 0px;
    margin-top: 2px !important;
    border-radius: 0rem 1.25rem 1.25rem 1.25rem;
    margin: 5px;
    background-color: #64B5F6;
    color: #fff;
    transition: all .3s cubic-bezier(.23,1,.32,1);
    box-shadow: 0 1px 3px 0 rgba(0,0,0,.1), 0 1px 2px 0 rgba(0,0,0,.06);
    position: relative;
    min-width: 150px;
  }
  .reverse .messaging--body {
    border-radius: 1.25rem 0rem 1.25rem 1.25rem;
    background-color: #ECECEC;
    color: #333;
    box-shadow: 0 1px 3px 0 rgba(0,0,0,.1), 0 1px 2px 0 rgba(0,0,0,.06);
  }
  .messaging--title {
    padding: 0px 0px 5px 15px;
    text-align: start;
    overflow: auto;
  }
  .messaging--title .messageRead{
    float: right;
    margin-right: 10px;
  }
  .messaging--title .human {
    font-size: 14px;
    font-weight: bold;
  }
  .messaging--title .time {
    font-size: 12px;
    display: inline-block;
  }
  .messaging-item {
    margin: 0px;
  }
  .messaging--body .message {
    margin: 0px 15px;
    text-align: left;
  }
  .messaging--body .message >>> img{
    width: 160px !important;
  }
  .seen .v-icon{
    font-size: 6px !important;
    vertical-align: middle;
  }
  .seen {
    color: #64B5F6;
  }
  .unReadList {
    /* position: absolute;
    right: 0px;
    padding: 15px 10px; */
    vertical-align: text-bottom;
  }
  .unReadList .v-icon{
    font-size: 10px !important;
  }
  .v-list__tile__title {
    font-size: 14px !important;
  }
  .v-list__tile__sub-title {
    font-size: 13px !important;
  }
  .unread-row .v-list__tile__title, .unread-row .v-list__tile__sub-title {
    font-weight: 800 !important;
  }
  .v-card--reveal, .v-card--add-contact {
    z-index: 1;
    top: -51px;
    right: 0;
    bottom: 0;
    position: absolute;
    width: 100%;
    background-color: #fff;
    height: max-content;
  }
  .avatar-chat {
    margin-left: -10px;
    -webkit-box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
    box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
  }
  .chat-room--toolbar {
    min-height: 48px !important;
  }
  .chat-room--toolbar .v-toolbar__title{
    font-size: 16px;
    font-weight: 400;
    white-space: normal;
    text-align: center;
  }
  .link {
      color: #019d8c !important;
  }

  .v-card__actions .v-btn {
      margin: 0 8px;
      min-width: 105px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ProfileDocuments/profile_comments.vue